/**
 * Normalises a WABA state entry at the API boundary.
 *
 * The BFF has shipped two field namings: the current `is_safe_mode_enabled` /
 * `is_marketing_messaging_blocked`, and the older `safe_mode_enabled` /
 * `outbound_marketing_blocked` still served by GET /waba/{id}/safe_mode.
 * Accepting both costs three lines and survives a redeploy.
 */
export var toWabaMarketingState = function (waba) {
    var _a, _b;
    return ({
        wabaId: waba.waba_id,
        isMarketingBlocked: Boolean((_a = waba.is_marketing_messaging_blocked) !== null && _a !== void 0 ? _a : waba.outbound_marketing_blocked),
        isSafeModeEnabled: Boolean((_b = waba.is_safe_mode_enabled) !== null && _b !== void 0 ? _b : waba.safe_mode_enabled)
    });
};
/**
 * Unwraps PartnerWabaStatesResponse.waba_ids.
 *
 * The field name is misleading: it holds objects, not id strings. Reading it as
 * a list of strings - or looking for `items` / `data` / `wabas` - yields an
 * empty list and a banner that silently never renders, so guard the shape and
 * drop anything without a usable `waba_id`.
 */
export var unpackWabaStates = function (data) {
    if (!Array.isArray(data === null || data === void 0 ? void 0 : data.waba_ids))
        return [];
    return data.waba_ids
        .filter(function (waba) {
        return Boolean(waba) &&
            typeof waba === "object" &&
            typeof waba.waba_id === "string" &&
            waba.waba_id.length > 0;
    })
        .map(toWabaMarketingState);
};
export var unpackPartnerSafeMode = function (data) {
    var _a;
    return ({
        partnerId: (_a = data === null || data === void 0 ? void 0 : data.partner_id) !== null && _a !== void 0 ? _a : "",
        safeModeEnabled: Boolean(data === null || data === void 0 ? void 0 : data.safe_mode_enabled)
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWVzc2FnaW5nLm1hcHBlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm1lc3NhZ2luZy5tYXBwZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUE7Ozs7Ozs7R0FPRztBQUNILE1BQU0sQ0FBQyxJQUFNLG9CQUFvQixHQUFHLFVBQ2xDLElBQTRCOztJQUNJLE9BQUEsQ0FBQztRQUNqQyxNQUFNLEVBQUUsSUFBSSxDQUFDLE9BQU87UUFDcEIsa0JBQWtCLEVBQUUsT0FBTyxDQUN6QixNQUFBLElBQUksQ0FBQyw4QkFBOEIsbUNBQUksSUFBSSxDQUFDLDBCQUEwQixDQUN2RTtRQUNELGlCQUFpQixFQUFFLE9BQU8sQ0FDeEIsTUFBQSxJQUFJLENBQUMsb0JBQW9CLG1DQUFJLElBQUksQ0FBQyxpQkFBaUIsQ0FDcEQ7S0FDRixDQUFDLENBQUE7Q0FBQSxDQUFDO0FBRUg7Ozs7Ozs7R0FPRztBQUNILE1BQU0sQ0FBQyxJQUFNLGdCQUFnQixHQUFHLFVBQzlCLElBQTZEO0lBRTdELElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLElBQUksYUFBSixJQUFJLHVCQUFKLElBQUksQ0FBRSxRQUFRLENBQUM7UUFBRSxPQUFPLEVBQUUsQ0FBQztJQUU5QyxPQUFPLElBQUssQ0FBQyxRQUFRO1NBQ2xCLE1BQU0sQ0FDTCxVQUFDLElBQUk7UUFDSCxPQUFBLE9BQU8sQ0FBQyxJQUFJLENBQUM7WUFDYixPQUFPLElBQUksS0FBSyxRQUFRO1lBQ3hCLE9BQU8sSUFBSSxDQUFDLE9BQU8sS0FBSyxRQUFRO1lBQ2hDLElBQUksQ0FBQyxPQUFPLENBQUMsTUFBTSxHQUFHLENBQUM7SUFIdkIsQ0FHdUIsQ0FDMUI7U0FDQSxHQUFHLENBQUMsb0JBQW9CLENBQUMsQ0FBQztBQUMvQixDQUFDLENBQUM7QUFFRixNQUFNLENBQUMsSUFBTSxxQkFBcUIsR0FBRyxVQUNuQyxJQUEyRDs7SUFDOUIsT0FBQSxDQUFDO1FBQzlCLFNBQVMsRUFBRSxNQUFBLElBQUksYUFBSixJQUFJLHVCQUFKLElBQUksQ0FBRSxVQUFVLG1DQUFJLEVBQUU7UUFDakMsZUFBZSxFQUFFLE9BQU8sQ0FBQyxJQUFJLGFBQUosSUFBSSx1QkFBSixJQUFJLENBQUUsaUJBQWlCLENBQUM7S0FDbEQsQ0FBQyxDQUFBO0NBQUEsQ0FBQyJ9